import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { CoreConfigService } from '@core/services/config.service';
import { AuthenticationService } from '../../../../core/service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CoreLoadingScreenService } from '@core/services/loading-screen.service';
import { UserAuthenticatedDTO } from 'app/core/requests/UserAuthenticatedDTO';
import { ActivatedRoute, Router } from '@angular/router';
import { ExchangeTokenRequest } from 'app/core/requests/ExchangeTokenRequest';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ShowConsentComponent} from "../../../shared/show-consent/show-consent.component";
import {LoginResponse} from "../../../../core/responses/LoginResponse";

@Component({
  selector: 'app-login-redirect-sso',
  templateUrl: './login-redirect-sso.component.html',
  styleUrls: ['./login-redirect-sso.component.scss'],
  providers: [TranslatePipe],
  encapsulation: ViewEncapsulation.None,
})
export class LoginRedirectSSOComponent implements OnInit, OnDestroy {
  //  Public
  public coreConfig: any;
  public loading = false;
  public subdomain: string;
  private readonly ngUnsubscribe = new Subject();
  private ssoUserInfo: any;

  loggedUser: UserAuthenticatedDTO;

  constructor(
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private _coreConfigService: CoreConfigService,
    private _route: ActivatedRoute,
    private _router: Router,
    private loader: CoreLoadingScreenService,
    public _translateService: TranslateService,
  ) {
    this.subdomain = this._route.snapshot.params['subdomain'];
    this.ssoUserInfo = JSON.parse(localStorage.getItem('ssoUserInfo'));
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
      },
    };
  }

  /**
   * On init
   */
  ngOnInit(): void {
    this.loader.show();
    this._route.fragment.subscribe
    (fragment => {
      if (fragment !== undefined && fragment.indexOf('state=') >= 0 && fragment.indexOf('id_token=') >= 0) {
        const fragmentParams = new URLSearchParams(fragment);
        const state = fragmentParams.get('state');
        const idToken = fragmentParams.get('id_token');

        try {
          const subdomain = JSON.parse(state).subDomain;
          const request: ExchangeTokenRequest = {
            subDomain: subdomain,
            token: idToken,
            email: this.ssoUserInfo.email
          };
          this.authenticationService.loginSSO(request).subscribe(
            (loginResponse: UserAuthenticatedDTO) => {
              if (loginResponse && !loginResponse.latestConsentAccepted) {
                this.requireUserAcceptance(loginResponse, subdomain);
              } else {
                localStorage.removeItem('ssoUserInfo');
                this.loader.hide();
                const returnUrl = localStorage.getItem('returnUrl') || `/${subdomain}/home`;
                localStorage.removeItem('returnUrl');
                this._router.navigate([returnUrl]);
              }
            },
            (error) => {
              this.loader.hide();
              this.ssoLoginFail(null);
            }
          );
        } catch (error) {
          this.ssoLoginFail(null);
        }
      } else {
        this.ssoLoginFail(null);
      }
    });

  }

  requireUserAcceptance(loginResponse: UserAuthenticatedDTO, subdomain: string) {
    this.loader.hide();
    const modalRef = this.modalService.open(ShowConsentComponent, {
      centered: true,
      backdrop: 'static',
      size: 'sm',
    });
    modalRef.componentInstance.userId = loginResponse.userId;
    modalRef.componentInstance.accessToken = loginResponse.accessToken;
    modalRef.componentInstance.userEmail = loginResponse.email;

    modalRef.result.then(({ res, email }: { res: boolean; email: string }) => {
      if (res) {
        const wrappedResponse: LoginResponse = {
          responseObject: loginResponse,
          isSuccess: true,
          errors: []
        }
        this.authenticationService.handleLoginResponse(wrappedResponse, false, email);
        localStorage.removeItem('ssoUserInfo');
        this.loader.hide();
        this._router.navigate(['/' + subdomain + '/home']);
      } else {
        this.ssoLoginFail("LOGIN.MISSING_CONSENT");
      }
    })
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  public ssoLoginFail(reason: string): void{
    this.ssoUserInfo.ssoLoginSuccess = false;
    this.ssoUserInfo.reason = reason;
    localStorage.setItem('ssoUserInfo', JSON.stringify(this.ssoUserInfo));
    this._router.navigate(['/' + this.ssoUserInfo.subDomain + '/authentication/login']);
  }
}
